import type { Client } from "./client";
import type { Site } from "./sites";

export enum DeviceMobilityType {
  FIXED = "fixed",
  MOBILE = "mobile",
}

export enum DeviceHardwareType {
  SGS_RPI = "sgs_rpi",
  CHAINWAY_C72 = "chainway_c72",
}

export enum StatusProcessingType {
  PRODUCT_STATUS_LOOP = "product_status_loop",
  SINGLE_FIXED = "single_fixed",
}

export interface Device {
  id: number;
  name?: string;
  handler_name?: string;
  serial_number: string;
  mac_address: string;
  identifier: string;
  is_active: boolean;
  blacklisted: boolean;
  mobility_type?: DeviceMobilityType | null;
  hardware_type?: DeviceHardwareType | null;
  status_processing_type?: StatusProcessingType | null;
  last_seen: Date;
  fixed_status?: string;
  selected_statuses?: string[];
  ip_address?: string;
  latitude: number | null;
  longitude: number | null;
  site?: Site;
  client?: Client;
  scan_threshold_in_seconds?: number;
}

export interface DeviceRegistrationPayload {
  name: string;
  site_id: number;
  mobility_type: DeviceMobilityType | null;
  status_processing_type: StatusProcessingType | null;
  handler_name?: string;
  fixed_status?: string;
  selected_statuses?: string[];
  scan_threshold_in_seconds?: number;
}

export interface DeviceUpdatePayload {
  name?: string;
  site_id?: number;
  mobility_type?: DeviceMobilityType | null;
  status_processing_type?: StatusProcessingType | null;
  handler_name?: string;
  fixed_status?: string;
  selected_statuses?: string[];
  scan_threshold_in_seconds?: number;
}
